export default __webpack_public_path__ + "static/media/ea-icon.86f2aa37.svg";